export class BookModel
{
  id: number=0;
  osis: string='';
  human: string='';
  chapters: number=0;
}

export enum BookTextField
{
  title= 'Book',
  id= 'Id',
  osis= 'Osis',
  human= 'Human',
  chapters= 'Chapters',
}
